import { Form, FormProps } from 'antd';
import styles from './index.module.scss';

export const ConsoleForm = (props: FormProps) => {
  return (
    <Form
      {...props}
      form={props.form}
      labelCol={props.labelCol || { span: 24 }}
      wrapperCol={props.wrapperCol || { span: 24 }}
      layout="vertical"
      className={`${styles.form} ${props.className || ''}`}
    >
      {props.children}
    </Form>
  );
};
